










































































































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { bannersCollection } from "../../db";

@Component
export default class EquipmentBanners extends Vue {
  @Getter banners;

  private search = "";
  private dialog = false;
  private formEditMode = false;
  private form = {
    id: undefined,
    name: "",
    color: "#000000",
    dark: false,
  };

  private headers = [
    {
      text: "Edit",
      sortable: false,
      value: "edit",
    },
    { text: "Name", value: "name" },
    { text: "Color", value: "color" },
    { text: "Dark Theme", value: "dark" },
    {
      text: "Delete",
      sortable: false,
      value: "delete",
    },
  ];

  async add() {
    await bannersCollection.add({
      name: this.form.name,
      color: this.form.color,
      dark: this.form.dark,
    });
    this.clearForm();
    this.dialog = false;
  }

  edit(item) {
    this.form = {
      id: item.id,
      name: item.name,
      color: item.color,
      dark: item.dark,
    };
    this.formEditMode = true;
    this.dialog = true;
  }

  async save() {
    await bannersCollection.doc(`${this.form.id}`).update({
      name: this.form.name,
      color: this.form.color,
      dark: this.form.dark,
    });
    this.dialog = false;
    this.formEditMode = false;
    this.clearForm();
  }

  async remove(item) {
    await bannersCollection.doc(`${item.id}`).delete();
  }

  close() {
    this.dialog = false;
    this.clearForm();
  }

  clearForm() {
    this.form = {
      id: undefined,
      name: "",
      dark: false,
      color: "#000000",
    };
  }
}
